import { render } from "./SpecialGAReferendumView.vue?vue&type=template&id=ba84be60"
import script from "./SpecialGAReferendumView.vue?vue&type=script&lang=js"
export * from "./SpecialGAReferendumView.vue?vue&type=script&lang=js"

import "./SpecialGAReferendumView.vue?vue&type=style&index=0&id=ba84be60&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__